module.exports = __webpack_public_path__ + "img/115-hungary.f8ec353b.svg";